/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AgeDataAllOf } from './AgeDataAllOf';
import {
    AgeDataAllOfFromJSON,
    AgeDataAllOfFromJSONTyped,
    AgeDataAllOfToJSON,
} from './AgeDataAllOf';
import type { BaseModel } from './BaseModel';
import {
    BaseModelFromJSON,
    BaseModelFromJSONTyped,
    BaseModelToJSON,
} from './BaseModel';

/**
 * 
 * @export
 * @interface AgeData
 */
export interface AgeData {
    /**
     * 
     * @type {number}
     * @memberof AgeData
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof AgeData
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof AgeData
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof AgeData
     */
    title?: string;
}

/**
 * Check if a given object implements the AgeData interface.
 */
export function instanceOfAgeData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AgeDataFromJSON(json: any): AgeData {
    return AgeDataFromJSONTyped(json, false);
}

export function AgeDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): AgeData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
        'title': !exists(json, 'title') ? undefined : json['title'],
    };
}

export function AgeDataToJSON(value?: AgeData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'title': value.title,
    };
}

